
    require(
      "!../../node_modules/gatsby/dist/loaders/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { 
     return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./advanced-0-clients.json") })
        }
      }, "path---advanced-0-clients");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby/dist/loaders/gatsby-module-loader?name=path---advanced-0-clients!./.cache/json/advanced-0-clients.json
// module id = ./node_modules/gatsby/dist/loaders/gatsby-module-loader/index.js?name=path---advanced-0-clients!./.cache/json/advanced-0-clients.json
// module chunks = 154